import { useState, useEffect } from "react";
import "./Homepage.css";
import "./Blog.css";
import Enqiry from "./Enqiry";
import MyVideo from "./image/video.mp4";
import Aboutimg from "./image/pexels-christina-morillo-1181396.jpg";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Carousel from "react-bootstrap/Carousel";
import contact_icon from "./image/contact-book.png";
import groupicon from "./image/group.png";
import { FaStar } from "react-icons/fa";
import { ImQuotesLeft } from "react-icons/im";
import handshake_icon from "./image/handshake.png";
import api_icon from "./image/api.png";
import why from "./image/why choose.png";
import virus from "./image/virus.gif";
import Ui from "./image/monitor.gif";
import app from "./image/smartphone.gif";
import graphic from "./image/hacker.gif";
import web from "./image/web-structure.gif";
import seo from "./image/page-optimization.gif";
import classroom from "./image/classroom.gif";
import tranning from "./image/ai.gif";
import blog_banner from "./image/Blog_banner.jpeg";
import aratbimg from "./image/artab2024-03-24 at 6.36.11 PM.png";
import nvimg from "./image/webnv2024-03-24 at 6.38.47 PM.png";
import rusrtimg from "./image/webrust2024-03-24 at 6.41.35 PM.png";
import whatapp from "./image/whatsapp.png";
import { Link, Outlet, useLocation } from "react-router-dom";
import right from "./image/right.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Homepage = () => {
  const { pathname } = useLocation();
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    AOS.init({
      once: false,
      disable: "mobile",
      duration: 1000,
      easing: "ease-out-cubic",
    });
  }, []);

  const handleRedirect = () => {
    const phoneNumber = "+919202109531"; // Replace with the actual phone number
    const message = "Hello! I would like to chat.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.location.href = whatsappUrl;
  };

  const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      const arrow = item.querySelector('.arrow');

      question.addEventListener('click', () => {
        const isOpen = answer.classList.contains('open');

        // Close all open answers
        document.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('open'));
        document.querySelectorAll('.arrow').forEach(a => a.classList.remove('open'));

        // Toggle current item
        if (!isOpen) {
          answer.classList.add('open');
          arrow.classList.add('open');
        }
      });
    });
  return (
    <>
      <img
        style={{
          height: 60,
          position: "fixed",
          bottom: 10,
          right: 10,
          zIndex: 999,
          cursor: "pointer",
        }}
        onClick={handleRedirect}
        src={whatapp}
        alt="..."
      />

      <div className="main">
        <video
          height="700px"
          autoPlay
          loop
          muted
          className=" object-cover"
          width="100%"
          src={MyVideo}
          controls={false}
        ></video>
        <div className="top-sec-conntet">
          <div className="row  justify-content-center align-content-center">
            <div className="col-lg-7 col-12 ">
              <h2
                data-aos="zoom-y-out"
                data-aos-delay="50"
                className="we_provide"
              >
                <span className="highlight"> Next-Gen Tech </span>for a Boundless Digital World.
              </h2>
             
            </div>
            <div className="col-lg-5 col-12">
              <div data-aos="flip-left" className="right_img">
                <img src={right} alt="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------- Start ABOUT-US-------------------------- */}
      <div className="main-section1">
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-12">
                <div data-aos="fade-up-right" className="about-sec">
                  <h3>About Us</h3>
                  <p
                    data-aos="fade-down"
                    data-aos-anchor="#example-anchor"
                    data-aos-offset="500"
                    data-aos-duration="500"
                  >
                    At REALTHINK TECHNOLOGY, we believe that the sky is the
                    limit when it comes to innovation. Our team of tech-savvy
                    experts are always on the lookout for the latest trends and
                    technologies to incorporate into our solutions. We don't
                    just follow the trends - we set them. Our dedication to
                    excellence and customer satisfaction is unmatched, and we go
                    above and beyond to ensure that our clients are completely
                    satisfied with the end result. But it's not just about the
                    end product - it's about the journey. We value the
                    relationships we build with our clients and see ourselves as
                    partners in their success. We understand that every business
                    is unique, which is why we tailor our solutions to meet the
                    specific needs and goals of each client. With REALTHINK
                    TECHNOLOGY by your side, you can rest assured that your
                    software solutions will be top-notch, reliable, scalable,
                    and secure. So why settle for mediocrity when you can have
                    excellence? Join us at REALTHINK TECHNOLOGY and let's push
                    the boundaries of what's possible together.
                  </p>
                  <div className="btn">
                    <Link className="name_btn" to="./About" eventKey="/About">
                      Know more...
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div data-aos="fade-up" className="about-img">
                  <img height="400px" width="100%" src={Aboutimg} alt="..." />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------- Start OUR-SERVICE-------------------------- */}
      <div data-aos="fade-up" className="service-section">
        <div className="container-fluid">
          <div class="container">
            <div class="row justify-content-center ">
              <div class="col-lg-12 text-center mb-10 ">
                <h2 className="section-title">Our Services</h2>
                <p className="services-p">
               <h5> Your ideas, powered by our technology.</h5>

At RealThink Technology, we deliver end-to-end digital solutions that solve real problems and accelerate growth. Whether you're a startup, SME, or enterprise — our services are designed to elevate your brand, streamline operations, and give you a digital edge.
                </p>
              </div>
              <div
                data-aos="fade-right"
                class="col-lg-3 col-md-5 col-sm-6 mb-2"
              >
                <div class="card ">
                  <div class="card-body">
                    <img className="card_img" src={virus} alt="..." />
                    <h4 class="mt-4 mb-3">Software Development</h4>
                    <p>
                    We turn ideas into powerful digital products. From complex web applications to real-time platforms, our dev team crafts code that works—and scales.
                     <p>🚀 Startup apps | </p>
                     <p>🧾 Business tools |</p>
                     <p>💻 Web platforms</p>
  
                    </p>
                  </div>
                </div>
              </div>
              <div
                data-aos="fade-right"
                class="col-lg-3  col-md-5 col-sm-6 mb-2"
              >
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={web} alt="..." />
                    <h4 class="mt-4 mb-3">Web Development</h4>
                    <p>
                    We build lightning-fast, responsive, and secure web applications using modern technologies like MongoDB, Express.js, React.js, and Node.js.
<p> ✅ Custom dashboards</p>
<p>  ✅ CRM systems</p>
<p>   ✅ eCommerce platforms</p>
<p>  ✅ Real-time web apps</p>
                     
                    
                     
                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="flip-up" class="col-lg-3  col-md-5 col-sm-6 mb-2">
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={app} alt="..." />
                    <h4 class="mt-4 mb-3">App Development</h4>
                    <p>
                    Your mobile presence starts here.

We develop high-performance Android applications using Java & Kotlin—tailored to meet your business needs and customer expectations.
<p>📲 Business apps</p>
<p>🛒 On-demand service apps</p>
<p>📍 Location-based & real-time apps</p>


                    </p>
                  </div>
                </div>
              </div>
              <div
                data-aos="flip-down"
                class="col-lg-3  col-md-5 col-sm-6 mb-2"
              >
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={tranning} alt="..." />
                    <h4 class="mt-4 mb-3">Artificial Intelligence Solutions</h4>
                    <p>
From smart automation to predictive insights, we build AI-driven applications that help businesses make faster decisions and deliver better user experiences.
<p>🧠 Chatbots & NLP</p>
<p>📊 Data analysis & forecasting</p>
<p>📈 Workflow automation</p>




                    </p>
                  </div>
                </div>
               
              </div>
              <div
                data-aos="fade-right"
                class="col-lg-3  col-md-5 col-sm-6 mb-2"
              >
                
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={Ui} alt="..." />
                    <h4 class="mt-4 mb-3">UI/UX Design</h4>
                    <p>
                    Our UI/UX team crafts user interfaces that are clean, intuitive, and designed to boost user engagement. From wireframes to final designs—we think like users and design with purpose.
                    <p>🎯 Figma & Adobe XD</p>
                    <p>📱 Mobile-first approach</p>
                    <p>🚀 Smooth user journeys</p>





                    </p>
                  </div>
                </div>
              </div>
              <div
                data-aos="fade-right"
                class="col-lg-3  col-md-5 col-sm-6 mb-2"
              >
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={seo} alt="..." />
                    <h4 class="mt-4 mb-3">Search Engine Optimization
                    </h4>
                    <p>
                    We help your website rank higher with technical SEO, content optimization, keyword research, and backlink building that aligns with your business goals.
                    <p>✅ On-Page & Off-Page SEO</p>
                    <p>✅ Technical SEO Audits</p>
                    <p>✅ Keyword Planning & Strategy</p>
                    

                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="flip-up" class="col-lg-3  col-md-5 col-sm-6 mb-2">
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={classroom} alt="..." />
                    <h4 class="mt-4 mb-3"> IT Training & Internship Programs</h4>
                    <p>
We offer industry-relevant IT training in Full Stack Development, AI with real projects, expert mentors, and job-ready certifications.
<p>🎓 100% practical</p>
<p>💼 Placement support</p>
<p>🌍 Online & Offline (Bhopal)</p>


                    </p>
                  </div>
                </div>
              </div>
              <div data-aos="flip-down" class="col-lg-3 col-md-5 col-sm-6 mb-2">
                
                <div class="card">
                  <div class="card-body">
                    <img height="60px" src={graphic} alt="..." />
                    <h4 class="mt-4 mb-3">Social Media Creatives
                    </h4>
                    <p>
                    Fuel your online presence.
                    We create engaging and on-brand content for platforms like Instagram, Facebook, LinkedIn, and YouTube.
                    <p>🔹 Post designs & templates</p>
                    <p>🔹 Stories, reels, and ad creatives</p>
                    <p>🔹 Campaign branding
                    </p>


                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------- END OUR-SERVICE-------------------------- */}
      <div data-aos="fade-up" className="main-section1">
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="heading">
                  <h3>WHY CHOOSE US ?</h3>
                  <p>
                    "At REALTHINK TECHNOLOGY, we understand that selecting the
                    right partner for your needs is crucial for success. <br />
                    Here's why we believe we're the perfect fit for you."
                  </p>
                </div>
              </div>
              <div className="row align-items-center">
                <div data-aos="fade-up-up" className="col-lg-4">
                  <div className="col-lg-12">
                    <div className="cardbox">
                      <h6>Expertise in Web Development:</h6>
                      <p>
                        Our team comprises highly skilled and experienced web
                        developers who are proficient in a wide range of
                        programming languages, frameworks, and technologies.
                        From front-end to back-end development, we have the
                        expertise to bring your vision to life.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="cardbox">
                      <h6>Customized Solutions</h6>
                      <p>
                        understand that every project is unique. That's why we
                        take a personalized approach to development, crafting
                        custom solutions tailored to your specific requirements
                        and objectives. Whether you need a simple website or a
                        complex web application, we have the skills and
                        creativity to deliver.
                      </p>
                    </div>
                  </div>
                </div>
                <div data-aos="fade-flip" className="col-lg-4">
                  <img src={why} className="img-fluid" alt="..." />
                </div>

                <div data-aos="fade-up-down" className="col-lg-4">
                  <div className="col-lg-12">
                    <div className="cardbox">
                      <h6>Responsive and Mobile-Friendly Designs</h6>
                      <p>
                        Our team comprises highly skilled and experienced web
                        developers who are proficient in a wide range of
                        programming languages, frameworks, and technologies.
                        From front-end to back-end development, we have the
                        expertise to bring your vision to life.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="cardbox">
                      <h6>Cutting-Edge Technologies</h6>
                      <p>
                        We stay up-to-date with the latest trends and
                        technologies in web development to ensure that our
                        clients always have access to the most innovative
                        solutions. Whether it's HTML5, CSS3, JavaScript
                        frameworks, or server-side technologies, we leverage the
                        latest tools and techniques to deliver best-in-class
                        results.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ----------Portfolio-sec-------------------------- */}
      <div data-aos="fade-up" className="service-section">
        <div class="container-fluid">
          <div class="container">
            <div class="row">
              <div className="col-lg-12 vlog">
                <h1 data-aos="fade-up" className="recent-title text-center">
                  Our Recent Projects
                </h1>
              </div>

              <div className="row">
                <div data-aos="flip-left" className="col-lg-4">
                  <div className="card">
                    <img src={aratbimg} alt="" />
                    <div className="card__content">
                      <h2 style={{ fontSize: 25, color: "#f35927" }}>
                        Aratb Property Booking Site
                      </h2>
                      <Link className="btn btn-primary" to="https://aratb.com/">
                        Visit Website
                      </Link>
                    </div>
                  </div>
                </div>
                <div data-aos="flip-right" className="col-lg-4">
                  <div className="card">
                    <img src={nvimg} alt="" />
                    <div className="card__content">
                      <h2 style={{ fontSize: 25, color: "#f35927" }}>
                        NVsparkle ECommerce
                      </h2>

                      <Link
                        className="btn btn-primary"
                        to="https://nvsparkle.com/"
                      >
                        Visit Website
                      </Link>
                    </div>
                  </div>
                </div>
                <div data-aos="flip-left" className="col-lg-4">
                  <div className="card">
                    <img src={rusrtimg} alt="" />
                    <div className="card__content">
                      <h2 style={{ fontSize: 25, color: "#f35927" }}>
                        Rust Console Community Social-Media
                      </h2>

                      <Link
                        className="btn btn-primary"
                        to="https://rust-consolecommunity.com"
                      >
                        Visit Website
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 vlog1">
                <div className="btn">
                    <Link className="name_btn" to="./Portfolio" eventKey="/Portfolio">
                      Know more...
                    </Link>
                  </div>
                  </div>
              </div>

              {/* <div className="row">
                <div className="col-lg-4">
                  <div className="blog-home">
                    <img
                      src={aratbimg}
                      style={{ width: "100%" }}
                      alt="..."
                    ></img>

                    <h5 className="mt-3 ">Aratb Property Booking Site</h5>

                    <Link
                      className="btn btn-primary mt-2 border-0"
                      to="https://aratb.com/"
                      rel="noreferrer"
                    >
                      Visit Website
                    </Link>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-home">
                    <img src={nvimg} style={{ width: "100%" }} alt=""></img>

                    <h5 className="mt-3">NVsparkle E-Commerce</h5>

                    <Link
                      className="btn btn-primary mt-2 border-0"
                      to="https://nvsparkle.com/"
                      rel="noreferrer"
                    >
                      Visit Website
                    </Link>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-home">
                    <img src={rusrtimg} style={{ width: "100%" }} alt=""></img>

                    <h5 className="mt-3">
                      Rust Console Community Social-Media
                    </h5>

                    <Link
                      className="btn btn-primary mt-2 border-0"
                      to="https://rust-consolecommunity.com"
                      rel="noreferrer"
                    >
                      Visit Website
                    </Link>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* ----------commitment-section-------------------------- */}
      <div className="main-section1">
        <div className="container-fluid">
          <div class="container">
            <div class="row">
            <div className="col-lg-12 vlog">
                <h1 data-aos="fade-up" className="recent-title text-center">
                  WORK FLOW
                </h1>
              </div>
              <div class="col-md-12">
                <div class="Yearly-timeline">
                  <div data-aos="zoom-in" class="timeline">
                    <Link to="/#" class="timeline-content">
                      <div class="timeline-icon">
                        <img height="50px" src={api_icon} alt="..." />
                      </div>
                      <h5>Innovation</h5>
                      <p>
                        We are committed to driving innovation and delivering
                        cutting-edge solutions that exceed our clients'
                        expectations.
                      </p>
                    </Link>
                  </div>
                  <div data-aos="zoom-in-up" class="timeline">
                    <Link to="/#" class="timeline-content">
                      <div class="timeline-icon">
                        <img height="50px" src={handshake_icon} alt="..." />
                      </div>
                      <h5>Commitment</h5>
                      <p>
                        We are dedicated to delivering exceptional service and
                        support to our clients.
                      </p>
                    </Link>
                  </div>
                  <div data-aos="zoom-in-down" class="timeline">
                    <Link to="/#" class="timeline-content">
                      <div class="timeline-icon">
                        <img height="50px" src={contact_icon} alt="..." />
                      </div>
                      <h5>Integrity</h5>
                      <p>
                        We hold ourselves to the highest standards of integrity
                        in all our interactions and transactions with our
                        clients.
                      </p>
                    </Link>
                  </div>
                  <div data-aos="zoom-in-left" class="timeline">
                    <Link to="/#" class="timeline-content">
                      <div class="timeline-icon">
                        <img height="50px" src={groupicon} alt="..." />
                      </div>
                      <h5>Value for Clients</h5>
                      <p>
                        We are committed to delivering exceptional value to our
                        clients in every interaction and engagement.
                      </p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ----------Blog-section-------------------------- */}
      <div className="service-section">
        <div className="container-fluid">
          <div class="container">
            <div class="row">
              <div class="col-lg-12 heading">
                <h2 data-aos="fade-up" className="recent-title text-center">
                  Our Latest Blog
                </h2>
              </div>
            </div>

            <div class="row">
              <div data-aos="zoom-in-left" class="col-lg-3 col-12">
                <div class="img-w">
                  <img
                    src={blog_banner}
                    style={{ width: "100%", height: 250 }}
                    alt="..."
                  />
                  <ul className="Social_icon">
                    <li>
                      <i class="fa fa-instagram"></i>
                    </li>
                    <li>
                      <i class="fa fa-youtube-play"></i>
                    </li>
                    <li>
                      <i class="fa fa-twitter"></i>
                    </li>
                    <li>
                      <i class="fa fa-linkedin-square"></i>
                    </li>
                  </ul>

                  <ul className="Social_icon">
                    <li className="insta">
                      <Link to="https://www.instagram.com/realthink_technology?igsh=MTVycmEwOXJrMDFlOA==">
                        <i class="fa fa-instagram"></i>
                      </Link>
                    </li>

                    <li className="youtub">
                      <Link to="https://youtube.com/@REALTHINKTECHNOLOGY?si=IdW5_rt2CDuf-pEJ">
                        <i className="fa fa-youtube-play"></i>
                      </Link>
                    </li>
                    <li className="twit">
                      <Link to=" https://x.com/RealThinkTech?t=dOMgf6wOURpq51OB-Ynxtg&s=08">
                        <i className="fa fa-twitter"></i>
                      </Link>
                    </li>
                    <li className="linked">
                      <Link to="https://www.linkedin.com/in/realthink-technology-7790a62bb?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app">
                        <i class="fa fa-linkedin-square"></i>
                      </Link>
                    </li>
                  </ul>
                  <h5>Our Best Service </h5>
                </div>
              </div>
              <div data-aos="zoom-in-right" className="col-lg-3 col-12">
                <div className="img-w">
                  <img
                    src="breaking.png"
                    style={{ width: "100%", height: 250 }}
                    alt="..."
                  />
                  <ul className="Social_icon">
                    <li className="insta">
                      <Link to="https://www.instagram.com/realthink_technology?igsh=MTVycmEwOXJrMDFlOA==">
                        <i class="fa fa-instagram"></i>
                      </Link>
                    </li>

                    <li className="youtub">
                      <Link to="https://youtube.com/@REALTHINKTECHNOLOGY?si=IdW5_rt2CDuf-pEJ">
                        <i className="fa fa-youtube-play"></i>
                      </Link>
                    </li>
                    <li className="twit">
                      <Link to=" https://x.com/RealThinkTech?t=dOMgf6wOURpq51OB-Ynxtg&s=08">
                        <i className="fa fa-twitter"></i>
                      </Link>
                    </li>
                    <li className="linked">
                      <Link to="https://www.linkedin.com/in/realthink-technology-7790a62bb?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app">
                        <i class="fa fa-linkedin-square"></i>
                      </Link>
                    </li>
                  </ul>
                  <h5>Announcement For Fresher</h5>
                </div>
              </div>
              <div data-aos="zoom-in-left" class="col-lg-3 col-12">
                <div class="img-w">
                  <img
                    src="How_design.png"
                    style={{ width: "100%", height: 250 }}
                    alt="..."
                  />
                  <ul className="Social_icon">
                    <li className="insta">
                      <Link to="https://www.instagram.com/realthink_technology?igsh=MTVycmEwOXJrMDFlOA==">
                        <i class="fa fa-instagram"></i>
                      </Link>
                    </li>

                    <li className="youtub">
                      <Link to="https://youtube.com/@REALTHINKTECHNOLOGY?si=IdW5_rt2CDuf-pEJ">
                        <i className="fa fa-youtube-play"></i>
                      </Link>
                    </li>
                    <li className="twit">
                      <Link href=" https://x.com/RealThinkTech?t=dOMgf6wOURpq51OB-Ynxtg&s=08">
                        <i className="fa fa-twitter"></i>
                      </Link>
                    </li>
                    <li className="linked">
                      <Link to="https://www.linkedin.com/in/realthink-technology-7790a62bb?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app">
                        <i class="fa fa-linkedin-square"></i>
                      </Link>
                    </li>
                  </ul>
                  <h5>How To Design Like a Pro</h5>
                </div>
              </div>
              <div data-aos="zoom-in-right" class="col-lg-3 col-12">
                <div class="img-w">
                  <img
                    src="Ai.png "
                    style={{ width: "100%", height: 250 }}
                    alt="..."
                  />

                  <ul className="Social_icon">
                    <li className="insta">
                      <Link to="https://www.instagram.com/realthink_technology?igsh=MTVycmEwOXJrMDFlOA==">
                        <i class="fa fa-instagram"></i>
                      </Link>
                    </li>

                    <li className="youtub">
                      <Link to="https://youtube.com/@REALTHINKTECHNOLOGY?si=IdW5_rt2CDuf-pEJ">
                        <i className="fa fa-youtube-play"></i>
                      </Link>
                    </li>
                    <li className="twit">
                      <Link to=" https://x.com/RealThinkTech?t=dOMgf6wOURpq51OB-Ynxtg&s=08">
                        <i className="fa fa-twitter"></i>
                      </Link>
                    </li>
                    <li className="linked">
                      <Link to="https://www.linkedin.com/in/realthink-technology-7790a62bb?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app">
                        <i class="fa fa-linkedin-square"></i>
                      </Link>
                    </li>
                  </ul>

                  <h5>Best Artificial Intelligence Website</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------Testimonials----------------------- */}
      <div data-aos="fade-up" className="main-section1">
        <div className="container-fluid">
          <div className="container">
            <div class="row">
              <div class="col-lg-12 text-center">
                <h2 data-aos="fade-down" className="section-title">
                  TESTIMONIALS
                </h2>
                <p data-aos="fade-up" className="services-p">
                  Checkout what our client says about REALTHINK TECHNOLOGY
                </p>
              </div>
            </div>

            <Carousel activeIndex={index} onSelect={handleSelect}>
              <Carousel.Item>
                <div className="row">
                  <div data-aos="flip-left" className=" col-lg-4 col-12 ">
                    <div className="box ">
                      <ImQuotesLeft />
                      <p>
                        "Working with Realthink Technology has been an absolute
                        pleasure. Their team is incredibly talented,
                        professional, and dedicated to delivering top-notch
                        results. I highly recommend them to anyone looking for
                        exceptional software solutions."
                      </p>
                      <div class="content">
                        <div class="info">
                          <div class="name">John Smith, CEO,Founder,</div>
                          <div class="job">Appinop Technologies </div>
                          <div class="stars">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                          </div>
                        </div>
                        <div class="image">
                          <img src="testi.png" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    data-aos="flip-right"
                    className=" col-lg-4 col-12  card_none"
                  >
                    <div class="box">
                      <ImQuotesLeft />
                      <p>
                        "Choosing Realthink Technology was one of the best
                        decisions we made for our business. Their team not only
                        delivered a high-quality product but also provided
                        invaluable guidance and support throughout the entire
                        process."
                      </p>
                      <div class="content">
                        <div class="info">
                          <div class="name">Michael Davis, Founder,</div>
                          <div class="job">Zignuts Technolab</div>
                          <div class="stars">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                          </div>
                        </div>
                        <div class="image">
                          <img src="Test1.png" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    data-aos="flip-left"
                    className=" col-lg-4 col-12  card_none"
                  >
                    <div class="box">
                      <ImQuotesLeft />
                      <p>
                        "Working with REALTHINK TECHNOLOGY was a breath of fresh
                        air. They took the time to understand our unique needs
                        and delivered a solution that exceeded our expectations.
                        Their communication was excellent"
                      </p>
                      <div class="content">
                        <div class="info">
                          <div class="name">Kristina Bellis</div>
                          <div class="job">Williams Web Solutions</div>
                          <div class="stars">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                          </div>
                        </div>
                        <div class="image">
                          <img src="Test3.png" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Carousel.Caption></Carousel.Caption>
              </Carousel.Item>

              <Carousel.Item>
                <div className="row">
                  <div className=" col-lg-4 col-12 card_none ">
                    <div className="box ">
                      <ImQuotesLeft />
                      <p>
                        "Working with Realthink Technology has been an absolute
                        pleasure. Their team is incredibly talented,
                        professional, and dedicated to delivering top-notch
                        results. I highly recommend them to anyone looking for
                        software solutions."
                      </p>
                      <div class="content">
                        <div class="info">
                          <div class="name">John Smith,Founder,CEO</div>
                          <div class="job">Appinop Technologies </div>
                          <div class="stars">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                          </div>
                        </div>
                        <div class="image">
                          <img src="testi.png" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className=" col-lg-4 col-12 ">
                    <div class="box">
                      <ImQuotesLeft />
                      <p>
                        "Choosing Realthink Technology was one of the best
                        decisions we made for our business. Their team not only
                        delivered a high-quality product but also provided
                        invaluable guidance and support throughout the entire
                        process."
                      </p>
                      <div class="content">
                        <div class="info">
                          <div class="name">Michael Davis, Founder,</div>
                          <div class="job">Zignuts Technolab</div>
                          <div class="stars">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                          </div>
                        </div>
                        <div class="image">
                          <img src="Test1.png" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" col-lg-4 col-12 card_none ">
                    <div class="box">
                      <ImQuotesLeft />
                      <p>
                        "Working with REALTHINK TECHNOLOGY was a breath of fresh
                        air. They took the time to understand our unique needs
                        and delivered a solution that exceeded our expectations.
                        Their communication was excellent"
                      </p>
                      <div class="content">
                        <div class="info">
                          <div class="name">Kristina Bellis</div>
                          <div class="job">Williams Web Solutions</div>
                          <div class="stars">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                          </div>
                        </div>
                        <div class="image">
                          <img src="Test3.png" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Carousel.Caption></Carousel.Caption>
              </Carousel.Item>

              <Carousel.Item>
                <div className="row">
                  <div className=" col-lg-4 col-12 card_none ">
                    <div className="box ">
                      <ImQuotesLeft />
                      <p>
                        "Working with Realthink Technology has been an absolute
                        pleasure. Their team is incredibly talented,
                        professional, and dedicated to delivering top-notch
                        results. I highly recommend them to anyone looking for
                        exceptional software solutions."{" "}
                      </p>
                      <div class="content">
                        <div class="info">
                          <div class="name">John Smith, CEO,</div>
                          <div class="job">Appinop Technologies </div>
                          <div class="stars">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                          </div>
                        </div>
                        <div class="image">
                          <img src="testi.png" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className=" col-lg-4 col-12 card_none ">
                    <div class="box">
                      <ImQuotesLeft />
                      <p>
                        "Choosing Realthink Technology was one of the best
                        decisions we made for our business. Their team not only
                        delivered a high-quality product but also provided
                        invaluable guidance and support throughout the entire
                        process."{" "}
                      </p>
                      <div class="content">
                        <div class="info">
                          <div class="name">Michael Davis, Founder,</div>
                          <div class="job">Zignuts Technolab</div>
                          <div class="stars">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                          </div>
                        </div>
                        <div class="image">
                          <img src="Test1.png" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" col-lg-4 col-12 ">
                    <div class="box">
                      <ImQuotesLeft />
                      <p>
                        "Working with REALTHINK TECHNOLOGY was a breath of fresh
                        air. They took the time to understand our unique needs
                        and delivered a solution that exceeded our expectations.
                        Their communication was excellent"
                      </p>
                      <div class="content">
                        <div class="info">
                          <div class="name">Kristina Bellis</div>
                          <div class="job">Williams Web Solutions</div>
                          <div class="stars">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                          </div>
                        </div>
                        <div class="image">
                          <img src="Test3.png" alt="..." />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Carousel.Caption></Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </div>

      <Enqiry />
      
      
      
      <Outlet />
    </>

    
  );
};

export default Homepage;
